import { render, staticRenderFns } from "./Spendenquittung.vue?vue&type=template&id=68e4e524&"
import script from "./Spendenquittung.vue?vue&type=script&lang=js&"
export * from "./Spendenquittung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports